import { Component, EventEmitter, Input, OnInit, Output, ViewContainerRef } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Toast, ToastsManager } from 'ng2-toastr/ng2-toastr';

import { BudgetService } from '../service/budget.service';
import { CompanyService } from '../service/company.service';
import { LoanService } from '../service/loan.service';
import { ProjectService } from '../service/project.service';

@Component({
  selector: 'app-loanschedules',
  templateUrl: './loanschedules.component.html',
  styleUrls: ['./loanschedules.component.css'],
})
export class LoanschedulesComponent implements OnInit {
  constructor(
    private loanService: LoanService,
    private companyService: CompanyService,
    private projectService: ProjectService,
    private budgetService: BudgetService,
    private route: ActivatedRoute,
    private router: Router,
    vRef: ViewContainerRef,
    private toastr: ToastsManager,
    public fb: FormBuilder
  ) {
    this.toastr.setRootViewContainerRef(vRef);

    this.projectId = localStorage.getItem('projectId');
    this.companyId = localStorage.getItem('companyId');
    this.showInstructions = false;
    // GET SAVED PROJECT NAME FROM DB(PROJECT TABLE)
    this.projectService.getProject(this.projectId).subscribe((projectData) => {
      this.projectName = projectData.data[0].project_name;
    });
  }

  // DECLARATION OF INPUT,OUTPUT VARIABLES TO COMMUNICATE B/W PARENT AND CHILD
  @Input() print: boolean;

  @Output() loanScheduleEmit: EventEmitter<any> = new EventEmitter();

  // DECLARATION OF ALL VARIABLES
  projectId: string;

  companyId: string;

  projectName: string;

  companyLogoUrl = '';

  businessPurchasePrice = 0;

  realEstatePurchasePrice = 0;

  costPerSquareFeet = 0;

  landAcquisitionCost = 0;

  operatingCapital = 0;

  maintenanceReserve = 0;

  realEstateBudgetTotal = 0;

  totalProjectCost = 0;

  totalFunds = 0;

  investmentName = '';

  loanAmount: number;

  futureValue: number;

  futureStartPoint: number;

  interestRate: string;

  term: number;

  monthlyPayment: number;

  loanArray = [];

  loans: any = [];

  months = [];

  updateLoanId = '';

  isAvailable: boolean;

  count = 0;
  // public pieChartLabels:string[] = ['Principal', 'Interest'];
  // public pieChartData:number[] = [30,40];
  // public pieChartType:string = 'pie';

  // public pieChartOptions: {
  //   responsive: true,
  //   title: {
  //       display: true,
  //       text: 'Custom Chart Title'
  //   }
  // }

  public barChartColors: any[] = [
    {
      backgroundColor: '#FFB3BA',
      borderColor: '#FFB3BA',
      pointBackgroundColor: '#FFB3BA',
      pointBorderColor: '#FFB3BA',
      pointHoverBackgroundColor: '#FFB3BA',
      pointHoverBorderColor: '#FFB3BA',
    },
    {
      backgroundColor: '#FFDFBA',
      borderColor: '#FFDFBA',
      pointBackgroundColor: '#FFDFBA',
      pointBorderColor: '#FFDFBA',
      pointHoverBackgroundColor: '#FFDFBA',
      pointHoverBorderColor: '#FFDFBA',
    },
    {
      backgroundColor: '#BAFFC9',
      borderColor: '#BAFFC9',
      pointBackgroundColor: '#BAFFC9',
      pointBorderColor: '#BAFFC9',
      pointHoverBackgroundColor: '#BAFFC9',
      pointHoverBorderColor: '#BAFFC9',
    },
  ];

  public barChartOptions: any = {
    scaleShowVerticalLines: false,
    responsive: true,

    legend: {
      fontFamily: 'Roboto',
      position: 'bottom',
      labels: {
        fontStyle: 'bold',
        boxWidth: 10,
        fontSize: 15,
        padding: 30,
        fontColor: 'black',
        margin: 50,
      },
    },
    tooltips: {
      callbacks: {
        label(tooltipItem) {
          return `$${tooltipItem.yLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
        },
      },
    },
    scales: {
      xAxes: [
        {
          barPercentage: 0.5,
          ticks: {
            beginAtZero: true,
            stacked: true,
            fontFamily: 'Roboto',
            fontStyle: 'bold',
            fontColor: 'black',
            fontSize: 14,
          },
        },
      ],
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            fontFamily: 'Roboto',
            fontSize: 14,
            fontColor: 'black',
            fontStyle: 'bold',
            callback(value) {
              // return value;
              const val = Math.round(value * 10) / 10;
              return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            },
          },
        },
      ],
    },
  };

  public barChartLabels: string[] = [
    'Mortage Loan',
    'SBM Loan',
    'SBA Loan',
    'PPM Loan',
    'Loan/Investment',
  ];

  public barChartType = 'bar';

  public barChartLegend = true;

  public barChartData: any[] = [
    { data: [65, 59, 80, 81, 56, 55, 40], label: 'Principal' },
    { data: [28, 48, 40, 19, 86, 27, 90], label: 'Interest' },
  ];

  showInstructions: boolean;

  // events
  public chartClicked(): void {
    // console.log(e);
  }

  public chartHovered(): void {
    // console.log(e);
  }

  ngOnInit() {
    this.getCompanyData();
    this.getLoansData();
  }

  // GET ALL SAVED LOANS FROM DB TO SHOW ALL LOANS(FROM LOAN TABLE)
  getLoansData() {
    let months = 0;
    this.loanService.getLoans(this.projectId).subscribe((loanData) => {
      this.loanArray = loanData.data;

      //
      // If there are elements in the DOM named "tableDataRows", alter their width dynamically. They don't exist
      // on a printout, so skip this code then.
      // TODO: Do we need to do any special width adjustment on the printout, too?
      //
      if (document.getElementById('tableDataRows')) {
        this.count = this.loanArray.length;
        const width1 = this.count * 385 + 80;
        setTimeout(() => {
          document.getElementById('tableDataRows').style.width = `${width1}px`;
        }, 100);
      }

      this.isAvailable = this.loanArray.length > 0;
      this.loanArray.forEach((element) => {
        if (element.term + element.future_start_point > months) {
          months = element.term + element.future_start_point;
        }
      });
      this.months = Array(months);
      this.loanScheduleEmit.emit({ loanScheduleEmit: true });
    });
  }

  // GET SAVED COMPANY LOGO FROM DB(COMPANY TABLE)
  getCompanyData() {
    this.companyService.getCompany(this.companyId).subscribe((res) => {
      this.companyLogoUrl = res.data[0].logoUrl;
    });
  }

  // Calculate Interest FOR EACH LOAN IN LOOP FROM HTML
  calculateInterest(loan: any) {
    const interest = Math.round(
      loan.monthly_payment * loan.term - loan.loan_amount + +loan.future_value
    );
    return interest;
  }

  // calculate loan table values for each loan in loop FROM HTML
  loanValues(loan) {
    this.loans = [];
    if (loan.monthly_payment && loan.interest_rate) {
      const principle = loan.loan_amount;
      const { interest_rate } = loan;
      let interest = loan.loan_amount * (interest_rate / (100 * 12));
      let principal = loan.monthly_payment - interest;
      let balance = loan.loan_amount - principal;
      const totalTerms = +loan.term + +loan.future_start_point;

      // console.log('Balance is ',balance,'principal',principal,'loan.loan_amount',loan.loan_amount,'interest_rate',interest_rate,'loan.monthly_payment',loan.monthly_payment,'interest',interest);
      for (let i = 0; i <= totalTerms; i++) {
        if (loan.loan_amount === loan.future_value) {
          balance = loan.loan_amount;
        }
        if (i === totalTerms) {
          // THIS IF BLOCK IS TO SHOW LAST LINE OF LOAN
          this.loans.push({
            month: i,
            monthly_payment: (+balance + +interest).toFixed(2),
            interest: interest.toFixed(2),
            principal: balance.toFixed(2),
            balance: '',
          });
          break;
        } else if (i >= loan.future_start_point) {
          if (
            i === loan.future_start_point ||
            ((loan.future_start_point === null || loan.future_start_point === 0) && i === 0)
          ) {
            // THIS IF BLOCK IS TO SHOW FIRST LINE OF LOAN
            this.loans.push({
              month: i,
              monthly_payment: '',
              interest: '',
              principal: '',
              balance: loan.loan_amount,
            });
          } else {
            // THIS ELSE BLOCK IS TO SHOW REST OF LINES OF LOAN
            this.loans.push({
              month: i,
              monthly_payment: loan.monthly_payment,
              interest: interest.toFixed(2),
              principal: principal.toFixed(2),
              balance: balance.toFixed(2),
            });
            interest = balance * (interest_rate / (100 * 12));
            if (i + 1 < totalTerms) {
              principal = loan.monthly_payment - interest;
              balance -= principal;
            }
          }
        } else {
          // THIS BLOCK IS FOR SHOWING 0 FOR LOANS THAT DON'T STARTS FROM 1ST MONTH
          this.loans.push({
            month: '0',
            monthly_payment: '0',
            interest: '0',
            principal: '0',
            balance: '0',
          });
        }
      }
    } else {
    }
    return this.loans;
  }

  // Open instructions in the nav bar when click on instructions button on header bar
  openModal() {
    if (this.showInstructions === true) {
      this.showInstructions = false;
    } else if (this.showInstructions === false) {
      this.showInstructions = true;
    }
  }

  // Close instructions in the nav bar when click on return button on header bar
  closeInstructions() {
    this.showInstructions = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/loanschedules/loanschedules.component.ts